import "./index.css";

import React from "react";
import Header from "../common/Header";
import BasicInformation from "./BasicInformation";
import PersonnelInformation from "./PersonnelInformation";
import SalaryInformation from "./SalaryInformation";
import History from "./History";
import ProjectInformation from "./ProjectInformation";
import { useSelector } from "react-redux";

export default function PersonalRecord() {
  const userInfo = useSelector((state) => state.userInfo);

  return (
    <React.Fragment>
      <Header title="PERSONAL RECORD" menudataSource={null} />
      <div style={{ margin: "40px auto", width: "95vw" }}>
        <BasicInformation userInfo={userInfo} />
      </div>
      <div style={{ margin: "40px auto", width: "95vw" }}>
        <PersonnelInformation />
      </div>
      <div style={{ margin: "40px auto", width: "95vw" }}>
        <SalaryInformation />
      </div>
      <div style={{ margin: "40px auto", width: "95vw" }}>
        <History />
      </div>
      <div style={{ margin: "40px auto", width: "95vw" }}>
        <ProjectInformation />
      </div>
    </React.Fragment>
  );
}
